module.exports = __webpack_public_path__ + "img/mobile-rental-assets-02.4926d495.png";